import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://hiveon-agile-project-management.onrender.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});


function describeError(err) {
  if (err?.response) {
    const { status, data, config } = err.response;
    let msg = `[${status}] ${config?.method?.toUpperCase?.() || ""} ${config?.url}`;
    const detail = typeof data === "string" ? data
                 : data?.detail || data?.title || data?.message || "";
    if (detail) msg += ` → ${detail}`;
    return msg;
  }
  return err?.message || "Network/unknown error";
}

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // stash full error for devtools
    window.__last_api_error__ = err;
    // attach a human message the caller can show
    err.userMessage = describeError(err);
    return Promise.reject(err);
  }
);

export default api;
